import { render } from "./ProductsDetailsPage.vue?vue&type=template&id=99f4c2e2"
import script from "./ProductsDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProductsDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__